<template>
    <section id="app-summary-report" class="content-wrapper">

        <app-page-top-section :title="$t('summary_report')" icon="briefcase">
            <app-default-button
                @click="exportPaymentSummary"
                :title="$fieldTitle('export', '', true)"/>
        </app-page-top-section>

        <div class="mb-3" v-html="filterHtml"></div>

        <app-table :id="table_id" :options="options" v-if="options.url" @action=""></app-table>

    </section>
</template>

<script>
import DatatableHelperMixin from "../../../../../common/Mixin/Global/DatatableHelperMixin";
import SummaryReportMixins from "./SummaryReportMixins";
import {SUMMARY_REPORT_EXPORT} from "../../../../Config/ApiUrl-CP";
import {numberWithCurrencySymbol} from "../../../../Helper/Helper";
import {mapGetters} from "vuex";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: 'SummaryReport',
    mixins: [DatatableHelperMixin, SummaryReportMixins],
    data() {
        return {
            table_id: 'summary-report-table',
            numberWithCurrencySymbol,
            exportLoading: false,
            branch_or_warehouse_id: this.getBranchOrWarehouseId,
        };
    },
    methods: {
        exportPaymentSummary() {
            window.open(urlGenerator(`${SUMMARY_REPORT_EXPORT}/?branch_or_warehouse_id=${this.getBranchOrWarehouseId}`,'_blank'));
        },
    },
    computed: {
        ...mapGetters(['getBranchOrWarehouseId']),
    },
    watch: {
        getBranchOrWarehouseId(new_id) {
            this.branch_or_warehouse_id = new_id
        },
    }
};
</script>
